import api from 'api/instance';

import { FetchResponse } from 'types/common';
import { EquipmentUnit } from 'types/equipment';
import { Status } from 'types/items';

const URL = `${process.env.REACT_APP_API_URL}`;

export const createEquipmentInventory = async (payload: {
  washHub: string;
  sku: string;
  quantity: number;
}) => {
  const { data } = await api.post(`${URL}/equipment-inventory`, payload);

  return data;
};

export const fetchEquipmentInventory = async (params: {
  washHub: string;
  page?: number;
  limit?: number;
  /** Filters, like the Items list: any of these SKUs, sites or statuses. */
  sku?: string[];
  venue?: string[];
  status?: number[];
}): Promise<FetchResponse<EquipmentUnit>> => {
  const { data } = await api.get<FetchResponse<EquipmentUnit>>(
    `${URL}/equipment-inventory/list`,
    { params },
  );

  return data;
};

/**
 * How many of a hub's equipment units are in each status, keyed by status,
 * for the status cards on Unit Tracking's Equipment tab.
 */
export const getEquipmentStatusCount = async (
  washHub: string,
): Promise<{ [status: number]: number }> => {
  const { data } = await api.get(`${URL}/equipment-inventory/status-count`, {
    params: { washHub },
  });

  const counts: { [status: number]: number } = {};
  data?.item?.count?.forEach((c: { _id: number; count: number }) => {
    counts[c._id] = c.count;
  });

  return counts;
};

/**
 * How many of an equipment SKU can be transferred (ClickUp 86bbmcvj4), shaped
 * like the item, case and package availability calls.
 */
export const getEquipmentAvailability = async (
  washHub: string,
  sku: string,
  operation: Status.TRANSFER_OUT | Status.TRANSFER_IN,
) => {
  const {
    data,
  } = await api.post(
    `${URL}/equipment-inventory/get-availability-for-transfer`,
    { sku, washHub, operation },
  );

  return data?.item as number;
};
